import React from "react";
import { useLocale, WithLocale } from "@insightfulscience/i18";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import SimpleTemplateTitle from "@insightfulscience/atomic-react/SimpleTemplate/Title";
import SimpleTemplateDescription from "@insightfulscience/atomic-react/SimpleTemplate/Description";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import SiteLayout from "@src/SiteLayout";
import ForgotPasswordForm from "@src/ForgotPasswordForm";

import { withErrorHandling } from "@src/AppError";
import redirectIf from "@src/utils/redirectIf";
import { isAuthorized } from "@src/services/auth";
import routes, { toReturnUrl } from "@src/routes";
import resources from "../../../locales/forgot-password-page";

const ForgotPasswordPage = () => {
	const [t] = useLocale("forgot-password-form");
	return (
		<SiteLayout>
			<PageTitle title={t("PAGE_TITLE")} />
			<SimpleTemplate>
				<SimpleTemplateTitle data-qa-selector="forgot-password-page-title">
					{t("FORM_TITLE")}
				</SimpleTemplateTitle>
				<SimpleTemplateDescription data-qa-selector="forgot-password-form-subtitle">
					{t("SUBTITLE")}
				</SimpleTemplateDescription>
				<ForgotPasswordForm />
			</SimpleTemplate>
		</SiteLayout>
	);
};

export default pipe(
	ForgotPasswordPage,
	WithLocale({ resources }),
	redirectIf(isAuthorized, toReturnUrl(routes.myAccount)),
	withErrorHandling,
);
